module.exports = new __parcel__URL__("actors.6fd2423d.svg").toString();